import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]
  static values = { wrapperSelector: String }

  connect() {
    // Set default wrapper selector if not provided
    if (!this.hasWrapperSelectorValue) {
      this.wrapperSelectorValue = '[data-nested-fields]'
    }
  }

  add(event) {
    event.preventDefault()
    
    const content = this.templateTarget.innerHTML
    const newId = new Date().getTime()
    const newContent = content.replace(/NEW_RECORD/g, newId)
    
    this.containerTarget.insertAdjacentHTML('beforeend', newContent)
  }

  remove(event) {
    event.preventDefault()
    
    const wrapper = event.target.closest(this.wrapperSelectorValue)
    if (wrapper) {
      const destroyInput = wrapper.querySelector('input[name*="_destroy"]')
      
      if (destroyInput) {
        destroyInput.value = '1'
        wrapper.classList.add('hidden')
      } else {
        wrapper.remove()
      }
    }
  }

}